<div class="bbStatistics">
	<div class="overlay-button" (click)="openMenu()">
		<i class="fa fa-bars"></i>
	</div>
	<iframe *ngIf="statisticsIframeSrc" [src]="statisticsIframeSrc"></iframe>
</div>
